/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Magnetic = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M95.16 15.539L92.923 1H74.077l.994 14.539zM42.929 15.539L43.923 1H25.077L22.84 15.539zM73.408 71.808L83.51 84.35l28.797-29.202-27.524 55.192-10.102-12.543L45.884 127z" />
    <path d="M80.957 65.728l3.284 4.078 17.231-17.473c-1.73-12.074-4.822-27.101-4.822-27.101H75.733L78.274 62.4l2.683 3.328zM45.744 105.563l11.165-22.39C47.214 82.115 39.615 73.972 39.615 64l2.65-38.769H21.349S15.385 54.194 15.385 64c0 19.579 12.755 35.981 30.359 41.563z" />
  </svg>
);

export default extendIcon(Magnetic);
